import styled from "styled-components";

export const Wrapper = styled.article`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  padding: 1.5rem 2rem;
  font-family: "Inter", sans-serif;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const Name = styled.span`
  font-weight: 600;
  font-size: 0.95rem;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 110px;
  resize: none;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 0.9rem 1.1rem;
  font-size: 0.9rem;
  font-family: inherit;
  &:focus {
    outline: none;
    border-color: #fe2f67;
    box-shadow: 0 0 0 2px rgba(254, 47, 103, 0.2);
  }
`;

export const ImageArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  box-sizing: border-box;
  border: 2px dashed #d0d0d0;
  border-radius: 12px;
  padding: 1rem;
`;

export const ImageInput = styled.input`
  width: 100%;
  padding: 0.65rem 1rem;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  font-size: 0.87rem;

  &:focus {
    outline: none;
    border-color: #fe2f67;
    box-shadow: 0 0 0 2px rgba(254, 47, 103, 0.18);
  }
`;

export const PreviewWrapper = styled.div`
  position: relative;
  width: 100%;
  max-height: 260px;
  overflow: hidden;
  border-radius: 10px;
`;

export const PreviewImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

export const RemoveBtn = styled.button`
  position: absolute;
  top: 6px;
  right: 6px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const PublishBtn = styled.button`
  align-self: flex-end;
  padding: 0.7rem 1.6rem;
  border: none;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 500;
  background: #fe2f67;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.25s;

  &:hover:not(:disabled) {
    background: #e61b55;
  }

  &:disabled {
    background: #ffcad8;
    cursor: not-allowed;
  }
`;

export const LocationToggle = styled.button<{ isActive: boolean }>`
  align-self: flex-start;
  padding: 0.5rem 1rem;
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  background: ${({ isActive }) => isActive ? '#fe2f67' : '#ffffff'};
  color: ${({ isActive }) => isActive ? '#ffffff' : '#666666'};
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ isActive }) => isActive ? '#e61b55' : '#f5f5f5'};
    border-color: #fe2f67;
    color: ${({ isActive }) => isActive ? '#ffffff' : '#fe2f67'};
  }
`;